import { FC } from 'react';
import { InputGrid } from '../../InputGrid';
import { FacebookAuthButton } from './FacebookAuthButton/FacebookAuthButton';
import { GoogleAuthButton } from './GoogleAuthButton/GoogleAuthButton';

export interface AuthButtonsProps {
  redirect?: string;
}

export const AuthButtons: FC<AuthButtonsProps> = ({ redirect }) => (
  <InputGrid>
    <GoogleAuthButton className="lg:col-span-6" redirect={redirect}>
      Login with Google
    </GoogleAuthButton>
    <FacebookAuthButton className="lg:col-span-6" redirect={redirect}>
      Login with Facebook
    </FacebookAuthButton>
  </InputGrid>
);
